import { type GetServerSideProps } from 'next';

import { getPhoneNumberData } from '../../../../modules/phoneVerification';

import { applyCorrelationIdHeader } from '../../../../utils/server/applyCorrelationIdHeader';
import { withEnhancedPageHandler } from '../../../../middlewares/withEnhancedPageHandler';

import {
  PhoneVerificationProvider,
  type TPhoneVerification,
} from '../../../../context/PhoneVerificationContext/PhoneVerificationContext';

import { Toast } from '../../../../components';

import { PhoneVerificationTemplate } from '../../../../templates';

interface IPhoneVerificationProps {
  data: TPhoneVerification;
  uuid: string;
  phoneId: string;
}

const PhoneVerification = (props: IPhoneVerificationProps) => {
  const { phoneId, uuid, data } = props;

  return (
    <PhoneVerificationProvider
      phoneId={phoneId}
      uuid={uuid}
      phoneVerificationData={data}
      locale="pt-BR"
    >
      <PhoneVerificationTemplate />
      <Toast closeButtonText={data.toast.closeButton} />
    </PhoneVerificationProvider>
  );
};

const getServerSidePropsHandler: GetServerSideProps = async ({
  params,
  res,
  req,
  query,
}) => {
  const { uuid: uuidParam, phoneId: phoneIdParam } = params;

  const initialPinValue = String(query.pin) || '';
  const uuid = String(uuidParam);
  const phoneId = String(phoneIdParam);

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const customHeaders = applyCorrelationIdHeader(req.headers);

  const data = await getPhoneNumberData({
    uuid,
    phoneId,
    locale: 'pt-BR',
    initialPinValue,
    customHeaders,
  });

  return {
    props: {
      data,
      uuid,
      phoneId,
      locale: 'pt-BR',
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default PhoneVerification;
